module.exports = __webpack_public_path__ + "img/icon-shop.12d20d01.png";